// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2UOiq","amount":"Amount_amount__3uUmt","tip":"Amount_tip__eUTpG","tipHeader":"Amount_tipHeader__3yNPa","tipsWrap":"Amount_tipsWrap__GNXZa"};